import { ComponentFactoryResolver, Injector, ViewContainerRef } from '@angular/core';

import { Observable, of as observableOf } from 'rxjs';

export enum DialogWidth {
  FullSize = 'auto',
  LargeX = '1300px', // 12
  Large = '1080px', // 10
  Medium = '860px', // 8
  Small = '640px', // 6
  SmallX = '420px', // 4
}

// Valid ARIA roles for a dialog element
export type DialogRole = 'dialog' | 'alertdialog';

export interface DialogConfigOptions {
  viewContainerRef?: ViewContainerRef | null;
  injector?: Injector;
  componentFactoryResolver?: ComponentFactoryResolver;
  // The ARIA role of the dialog element
  role?: DialogRole;
  data?: {};
  // Whether the user can use escape or clicking outside to close a modal
  disableClose?: boolean;
  // If close isn't disabled, should we show the close button?
  showCloseButton?: boolean;
  width?: string | DialogWidth;
  maxWidth?: string;
  height?: string;
  backdropStyle?: 'cover' | 'default';
  disableCloseOnBackdrop?: boolean;
  containerOptions?: {
    hasPadding?: boolean;
  };
  closeTooltip?: string;
  closeGuard?: () => Observable<boolean>;
}

export interface DialogConfig extends DialogConfigOptions {
  role: DialogRole;
  disableClose: boolean;
  showCloseButton: boolean;
  level: number;
  closeGuard: () => Observable<boolean>;
}

export function buildDialogConfig(options: DialogConfigOptions = {}): DialogConfig {
  return {
    role: <DialogRole>'dialog',
    disableClose: false,
    showCloseButton: true,
    level: 0,
    closeGuard: () => observableOf(true),
    backdropStyle: 'default',
    closeTooltip: 'rtu.dialog.close_tooltip',
    ...options,
  };
}
